export const inputStyle = (isInputFocused?: boolean) => ({
  display: "flex",
  width: "100%",
  height: "56px",
  margin: "10px 0",
  padding: "0px",
  border: "1px solid #ddd",
  borderRadius: "4px",
  backgroundColor: "#f5f7fa",
  boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
  ...(isInputFocused
    ? {
        borderColor: "#007bff",
        boxShadow: "0 0 0 2px rgba(0, 123, 255, 0.25)",
      }
    : {}),
});

export const buttonStyle = {
  display: "inline-block",
  padding: "10px 20px",
  fontSize: "16px",
  color: "#fff",
  backgroundColor: "#007bff",
  border: "none",
  borderRadius: "4px",
  cursor: "pointer",
  transition: "background-color 0.3s ease",
};

export const buttonHoverStyle = {
  backgroundColor: "#0056b3",
};

export const formContainerStyle = {
  display: "flex",
  flexDirection: "column",
  maxWidth: "400px",
  margin: "auto",
  padding: "20px",
  border: "1px solid #ccc",
  borderRadius: "8px",
};

export const formFieldStyle = {
  marginBottom: "20px",
};

export const submitButtonStyle = {
  marginTop: "20px",
};

export const primaryBtnStyle = {
  display: "flex",
  flexDirection: "row",
  justifyContent: "center",
  alignItems: "center",
  padding: "10px 24px",
  gap: "10px",

  height: "40px",

  background: "#025498",
  borderRadius: "32px",
  color: "#ffffff",
};

export const primaryBtnStyleOutline = {
  display: "flex",
  flexDirection: "row",
  justifyContent: "center",
  alignItems: "center",
  padding: "10px 24px",
  gap: "10px",

  height: "40px",
  borderWidth: "1px",
  borderColor: "#025498",
  borderRadius: "32px",
};

export const sidebarText = {
  fontFamily: "Source Sans Pro",
  fontSize: "14px",
  fontWeight: "600",
  lineHeight: "17.07px",
  textAlign: "left",
  color: "#343434",
};

export const sidebarItemContainer = {
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  padding: "18px 16px",
  gap: "10px",

  width: "270px",
  height: "50px",

  marginHorizontal: "10px",
  borderRadius: "100px",
};

export const pageHeading = {
  fontFamily: "Montserrat",
  fontSize: "32px",
  fontWeight: "700",
  lineHeight: "39.01px",
  textAlign: "left",
  color: "#343434",
};
